import React from 'react';
import './Registration.css';

const RegistrationSuccess: React.FC = () => {
  return (
    <div className="login-container">
      <div className="login-box">
        <div className="logo">
          <h1>Intern Trackr</h1>
          <p className="tagline">Anytime. Anywhere.</p>
        </div>
        <div className="success-message">
          <h2>Registration Successful!</h2>
          <p>Please check your email to verify your account.</p>
          <p>After verifying your email, you can log in to your account.</p>
        </div>
        <div className="info-box">
          <p>Haven't received the email?</p>
          <p>Please check your spam folder or contact support.</p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
